import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { CSSProperties, FC, useState } from 'react';
import { usePropsValue } from '../hooks/use-props-value';
import { KeyboardModal } from '../keyboard';
import { Passcode } from './passcode';
import './styles/passcode-input.less';

export type PasscodeKeyboardProps = {
  gridsCount?: number;
  isPlain?: boolean;
  defaultValue?: string;
  onInputFinish: (value: string) => Promise<void>;
  className?: string;
  style?: CSSProperties;
};
export const PasscodeKeyboard: FC<PasscodeKeyboardProps> = (props) => {
  const [focused, setFocused] = useState(false);
  const [isError, setIsError] = useState(false);
  const gridsCount = props.gridsCount || 6;

  const [value, setValue] = usePropsValue({
    defaultValue: (props.defaultValue || '').substring(0, gridsCount),
  });

  const onPasscodeFocus = hooks.useCallbackRef(() => {
    setFocused(true);
  });
  const onPasscodeBlur = hooks.useCallbackRef(() => {
    setFocused(false);
  });

  const onInputChange = hooks.useCallbackRef((key: string) => {
    if (value.length < gridsCount) {
      setIsError(false);
      const nextValue = `${value}${key}`;
      setValue(nextValue);
      if (nextValue.length === gridsCount) {
        props.onInputFinish(nextValue).catch(() => {
          setIsError(true);
        });
      }
    }
  });
  const onBackSpace = hooks.useCallbackRef(() => {
    setIsError(false);
    setValue(value.substring(0, value.length - 1));
  });

  return (
    <div className={classNames('v-passcode-keyboard', props.className)} style={props.style}>
      <Passcode
        isFocused={focused}
        value={value || ''}
        onFocus={onPasscodeFocus}
        onBlur={onPasscodeBlur}
        isError={isError}
        isPlain={props.isPlain}
      />
      <KeyboardModal
        visible={focused}
        keyboardProps={{ onInput: onInputChange, onBackSpace, type: 'pure_number' }}
        onClose={onPasscodeBlur}
      />
    </div>
  );
};
